export default __webpack_public_path__ + "static/media/bg-hero-1.c7f64614.m4v";